/**
 * Extracts the date portion (YYYY-MM-DD) from an ISO 8601 string
 * without applying any timezone or date conversion.
 *
 * ⚠️ This function treats the input purely as a string.
 * It does NOT create Date or Moment instances.
 *
 * @param {string} isoString - ISO 8601 datetime string (e.g. "2026-01-12T00:00:00.000Z")
 * @returns {string} The extracted date in YYYY-MM-DD format, or an empty string if invalid
 */
export const formatISOString = (isoString) => {
    return isoString.split("T")[0];
}